import React, {useCallback, useState} from "react";
import {IconButton} from "../../../features/management-v2/import/inputs";
import BasicText, {BasicTextArea} from "../../../components/form-v2/basic-text";
import SaveIcon from "@mui/icons-material/Save";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "../hooks/useNavigateWithClientID";
import {useSiren} from "../SirenContext";
import {TextToSpeechPreview} from "../components/TextToSpeechPreview";

export const AudioTextToSpeech: React.FC = () => {
    const {navigateWithClientID} = useNavigateWithClientID();
    const {clientID} = useSiren();

    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState<string | null>(null);
    const [name, setName] = useState("");
    const [content, setContent] = useState("");

    const save = useCallback(async () => {
        if (!clientID) return;
        setSaving(true);
        setSaveError(null);
        try {
            await platformAPI.post("api/siren/audio-files/tts", {name, content, clientID});
            navigateWithClientID("/siren/audio?subPage=files");
        } catch {
            setSaveError("error creating audio file");
        } finally {
            setSaving(false);
        }
    }, [name, content, clientID]);

    return (
        <div className="bg-white shadow-md p-4 flex flex-col gap-4">
            <h1 className="text-lg font-semibold">Create Audio File from Text-to-Speech</h1>
            <BasicText label="Name" value={name} onChange={setName} required/>
            <BasicTextArea label="Content" value={content} onChange={setContent} required/>
            <div className="flex flex-col gap-4">
                {content.length > 10 ? (
                    <>
                        <TextToSpeechPreview content={content}/>
                        <IconButton onClick={save} text="Create" icon={<SaveIcon/>} loading={saving}/>
                    </>
                ) : (
                    <p className="text-xs text-light-grey">Enter at least 10 characters to preview and create.</p>
                )}
                {saveError && <p className="text-center text-red">{saveError}</p>}
            </div>
        </div>
    );
};
